/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import Title from '../../../utils/title-utils';
import Monitoring from './slo-monitoring/Monitoring';
import FeatureServiceTabs from '../../../components/FeatureServiceTabs';
import { Paper } from '@mui/material';

const ServiceLevelObjectives = () => {
  return (
    <div id="content" className="content-shadow overflow-y-scroll h-100">
      <Title title="SLO Monitoring" />
      <div className="content-head">
        <div>
          <div className="f3 fw7 mb3">Services</div>
          <FeatureServiceTabs />
        </div>
      </div>
      <div className="pa5 " data-testid="tabs-content">
        <div>
          <Paper square>
            <div className="pa4">
              <Monitoring />
            </div>
          </Paper>
        </div>
      </div>
    </div>
  );
};

export default ServiceLevelObjectives;
